<template>
    <div style="padding:20px">
        <div >
            <a-input v-model:value="queryParam.queryTxt" style="width:300px" placeholder="请输入名称 / 账号" />
            <a-date-picker :allowClear="false" style="margin-left:20px" v-model:value="queryParam.date" />


            <a-radio-group style="margin-left:20px" v-model:value="showType" @change="query" name="radioGroup">
                <a-radio :value="2">按商家显示</a-radio>
                <a-radio :value="1">按店铺显示</a-radio>
                <a-radio :value="3">按链接显示</a-radio>
            </a-radio-group>

            <a-button :loading="loading" @click="query" style="float:right;margin-right:20px" type="primary">
                <template #icon><SearchOutlined /></template>
                搜索
            </a-button>

            <a-button :loading="loading" @click="downloadAll" style="float:right;margin-right:20px"  >
                <template #icon><download-outlined /></template>
                合并下载
            </a-button>
            <a-button :loading="loading" @click="downloadZip" style="float:right;margin-right:20px"  >
                <template #icon><download-outlined /></template>
                下载压缩包
            </a-button>
            <a-button
                :loading="batchDownloading"
                :disabled="selectedRows.length === 0"
                @click="batchDownload"
                style="float:right;margin-right:20px"
                type="primary"
                ghost
            >
                <template #icon><download-outlined /></template>
                批量下载<span v-if="selectedRows.length > 0">({{ selectedRows.length }})</span>
            </a-button>
        </div>
        <div style="margin-top:20px">
            <a-table :loading="loading" :scroll="{ y: tableHeight }" :pagination="false" :dataSource="list" :columns="columns" :row-selection="rowSelection" :row-key="rowKey" >
                <template #bodyCell="{ column,text, record }">
                    <template v-if="column.key === 'num'" >
                        <a-tag color="#2db7f5" >{{text}}</a-tag>
                    </template>
                    <template v-else-if="column.key === 'orderNum'" >
                        <a-tag color="#f56c6c" v-if="text<record.Num">{{text}}</a-tag>
                        <a-tag color="#87d068" v-else>{{text}}</a-tag>
                    </template>
                    <template v-else-if="column.key==='action'">
                        <a-button :loading="operateing"  @click="download(record)" style="margin-left:0px"  type="dashed" shape="circle">
                            <template  #icon><download-outlined /></template>
                        </a-button>

                        <a-tooltip placement="bottom">
                            <template #title>
                            <span>一键登陆</span>
                            </template>
                            <a-button @click="login(record)" type="dashed" style="margin-left:10px" shape="circle">
                                <template #icon><ie-outlined /></template>
                            </a-button>
                        </a-tooltip>
                            
                        
                        <a-tooltip placement="bottom">
                            <template #title>
                            <span>下载无佣金版本</span>
                            </template>
                            <a-button :loading="operateing"  @click="downloadNo(record)" style="margin-left:10px"  type="dashed" shape="circle">
                                <template  #icon><download-outlined /></template>
                            </a-button>
                        </a-tooltip>
                            
                    </template>
                    <template v-else-if="column.key==='advanceMoney'">
                        <b>￥ {{ text.toFixed(2) }}</b>
                    </template>
                    <template v-else-if="column.key==='actualCommission'">
                        <b>￥ {{ text.toFixed(2) }}</b>
                    </template>
                    <template v-else-if="column.key==='praiseCommission'">
                        <b>￥ {{ text.toFixed(2) }}</b>
                    </template>
                    <template v-else-if="column.key==='receivable'">
                        <b>￥ {{ text.toFixed(2) }}</b>
                    </template>
                </template>

                <template #summary>
                    <a-table-summary fixed>
                    <a-table-summary-row>
                        <a-table-summary-cell :col-span="3">
                            <div style="text-align:center">
                                <b>统计</b>
                            </div>
                        </a-table-summary-cell>
                        <a-table-summary-cell>
                            <a-tag color="#2db7f5">{{totals.num}}</a-tag>
                        </a-table-summary-cell>
                        <a-table-summary-cell>
                            <a-tag v-if="totals.orderNum<totals.num" color="error">{{totals.orderNum}}</a-tag>
                            <a-tag v-else color="success">{{totals.orderNum}}</a-tag>
                        </a-table-summary-cell>
                        <a-table-summary-cell>
                            <div style="font-weight:600">
                                ￥ {{totals.advanceMoney.toFixed(2)}}
                            </div>
                        </a-table-summary-cell>
                        <a-table-summary-cell>
                            <div style="font-weight:600">
                                ￥ {{totals.actualCommission.toFixed(2)}}
                            </div>
                        </a-table-summary-cell>
                        <a-table-summary-cell>
                            <div style="font-weight:600">
                                ￥ {{totals.praiseCommission.toFixed(2)}}
                            </div>
                        </a-table-summary-cell>
                        <a-table-summary-cell>
                            <div style="font-weight:600">
                                ￥ {{totals.receivable.toFixed(2)}}
                            </div>
                        </a-table-summary-cell>
                    </a-table-summary-row>
                    </a-table-summary>
                </template>
            </a-table>
        </div>

    </div>
</template>
<script>
import { ref, computed } from 'vue';
import { taskGetShopReportDownloadReq,memberLoginReq,uri,taskGetMemberReportDownloadReq,taskGetGoodsReportDownloadReq} from '@/request.js';
import dayjs from 'dayjs';
import {config} from '../config'

function formatDate(date) {
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    return y + '-' + m + '-' + d;
}


// import { useRouter } from 'vue-router';
// import { message } from 'ant-design-vue';
import { SearchOutlined,DownloadOutlined,IeOutlined } from '@ant-design/icons-vue';

export default {
    components: {
        SearchOutlined,DownloadOutlined,IeOutlined
    },
    setup(){
        const showType=ref(2);
        let agentId=0;
        const queryParam=ref({
            queryTxt:"",
            date:dayjs(formatDate(new Date()), "YYYY/MM/DD"),
        })
        const operateing=ref(false);
        const batchDownloading=ref(false);
        const selectedRowKeys=ref([]);
        const selectedRows=ref([]);
        const rowKey=(record)=>{
            if(showType.value==1) return 'shop_'+record.ShopId;
            if(showType.value==3) return 'goods_'+record.GoodsId;
            return 'member_'+record.MemberId;
        };
        const rowSelection=computed(()=>({
            selectedRowKeys:selectedRowKeys.value,
            onChange:(keys,rows)=>{
                selectedRowKeys.value=keys;
                selectedRows.value=rows;
            },
        }));
        const tableHeight=ref(0);
        tableHeight.value=document.documentElement.clientHeight-260;
        const loading=ref(false);
        const list=ref([]);
        const query=()=>{
            loading.value=true;
            selectedRowKeys.value=[];
            selectedRows.value=[];
            if(showType.value==1){
                taskGetShopReportDownloadReq({
                    date:formatDate(new Date(queryParam.value.date)),
                    queryTxt:queryParam.value.queryTxt,
                },(res)=>{
                    list.value=res.Result.List;
                    agentId=res.Result.AgentId;
                    loading.value=false;
                })
            }
            else if(showType.value==3){
                taskGetGoodsReportDownloadReq({
                    date:formatDate(new Date(queryParam.value.date)),
                    queryTxt:queryParam.value.queryTxt,
                },(res)=>{
                    list.value=res.Result.List;
                    agentId=res.Result.AgentId;
                    loading.value=false;
                })
            }
            else{
                taskGetMemberReportDownloadReq({
                    date:formatDate(new Date(queryParam.value.date)),
                    queryTxt:queryParam.value.queryTxt,
                },(res)=>{
                    list.value=res.Result.List;
                    agentId=res.Result.AgentId;
                    loading.value=false;
                })
            }
            
        };
        const downloadNo=(record)=>{
            if(showType.value==1){
                window.open(uri+"/task/GetExlNo?shopId="+record.ShopId+"&date="+formatDate(new Date(queryParam.value.date)));
            }
            else if(showType.value==3){
                window.open(uri+"/task/GetGoodsExlNo?goodsId="+record.GoodsId+"&date="+formatDate(new Date(queryParam.value.date)));
            }
            else{
                window.open(uri+"/task/GetMemberExlNo?memberId="+record.MemberId+"&date="+formatDate(new Date(queryParam.value.date)));
            }
        }

        const download=(record)=>{
            if(showType.value==1){
                window.open(uri+"/task/GetExl?shopId="+record.ShopId+"&date="+formatDate(new Date(queryParam.value.date)));
            }
            else if(showType.value==3){
                window.open(uri+"/task/GetGoodsExl?goodsId="+record.GoodsId+"&date="+formatDate(new Date(queryParam.value.date)));
            }
            else{
                window.open(uri+"/task/GetMemberExl?memberId="+record.MemberId+"&date="+formatDate(new Date(queryParam.value.date)));
            }
            
        }
        const login=(record)=>{
            memberLoginReq({
                phone:record.Phone,
                password:record.LoginPwd,
            },(res)=>{
                window.open(config.merchantServer+"/#/?token="+res.Message);
            })
        }

        const batchDownload=()=>{
            if(selectedRows.value.length===0) return;
            batchDownloading.value=true;
            const date=formatDate(new Date(queryParam.value.date));
            selectedRows.value.forEach((record,index)=>{
                setTimeout(()=>{
                    let url='';
                    if(showType.value==1){
                        url=uri+"/task/GetExl?shopId="+record.ShopId+"&date="+date;
                    } else if(showType.value==3){
                        url=uri+"/task/GetGoodsExl?goodsId="+record.GoodsId+"&date="+date;
                    } else {
                        url=uri+"/task/GetMemberExl?memberId="+record.MemberId+"&date="+date;
                    }
                    const a=document.createElement('a');
                    a.href=url;
                    a.download='';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    if(index===selectedRows.value.length-1){
                        batchDownloading.value=false;
                    }
                },index*800);
            });
        };
        const downloadAll=()=>{
            window.open(uri+"/task/GetAgentExl?agentId="+agentId+"&queryTxt="+queryParam.value.queryTxt+"&date="+formatDate(new Date(queryParam.value.date)));
        }
        const downloadZip=()=>{
            window.open(uri+"/task/GetAgentZip?agentId="+agentId+"&queryTxt="+queryParam.value.queryTxt+"&date="+formatDate(new Date(queryParam.value.date)));
        }
        const totals = computed(() => {
            let num = 0;
            let orderNum = 0;
            let advanceMoney = 0;
            let actualCommission = 0;
            let receivable = 0;
            let praiseCommission=0;
            list.value.forEach(({
                OrderNum,
                Num,
                AdvanceMoney,
                ActualCommission,
                Receivable,
                PraiseCommission
            }) => {
                orderNum += OrderNum;
                num += Num;
                advanceMoney += AdvanceMoney;
                actualCommission += ActualCommission;
                receivable += Receivable;
                praiseCommission+=PraiseCommission;
            });
            return {
                praiseCommission,
                orderNum,
                num,
                advanceMoney,
                actualCommission,
                receivable,
            };
        });
        query();
        return{
            downloadNo,
            showType,
            downloadZip,
            login,
            totals,
            downloadAll,
            download,
            batchDownload,
            batchDownloading,
            selectedRows,
            rowSelection,
            rowKey,
            queryParam,
            operateing,
            tableHeight,
            loading,
            list,
            query,
            columns: [
            {
                    title: '商品Id',
                    dataIndex: 'GoodsId',
                    key: 'goodsId',
                },
                {
                    title: '店铺名称',
                    dataIndex: 'ShopName',
                    key: 'shopName',
                },
                {
                    title: '商家名称',
                    dataIndex: 'MemberName',
                    key: 'memberName',
                },
                {
                    title: '发布单数',
                    dataIndex: 'Num',
                    key: 'num',
                },
                {
                    title: '完成单数',
                    dataIndex: 'OrderNum',
                    key: 'orderNum',
                },
                {
                    title: '应收货款',
                    dataIndex: 'AdvanceMoney',
                    key: 'advanceMoney',
                },
                {
                    title: '应收佣金',
                    dataIndex: 'ActualCommission',
                    key: 'actualCommission',
                },
                {
                    title: '好评佣金',
                    dataIndex: 'PraiseCommission',
                    key: 'praiseCommission',
                },
                {
                    title: '合计',
                    dataIndex: 'Receivable',
                    key: 'receivable',
                },
                {
                    title: '操作',
                    key: 'action',
                },
            ],
        }
    }
}
</script>
